import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CurrencyEnum } from '../../../../lib/enums/currency.enum';
import { OrderSideEnum } from '../../../../lib/enums/order-side.enum';
import { PredefinedMilisecondsTypeEnum } from '../../../../lib/enums/predefined-miliseconds-type.enum';
import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store/index';
import { formatNumber } from '../../../../lib/util/DataHelpers';

import IconSuccessWeb from '../../../../assets/img/wallet/completed_order.svg';
import IconRejectWeb from '../../../../assets/img/wallet/failed_order.svg';
import IconPendingMob from '../../../../assets/img/wallet/icon_pending_eur_order.svg';
import IconRejectMob from '../../../../assets/img/wallet/icon_rejected_eur_order.svg';
import IconSuccessMob from '../../../../assets/img/wallet/icon_success_eur_order.svg';
import IconPendingWeb from '../../../../assets/img/wallet/pending_order.svg';
import { ButtonTypesEnum } from '../../../../components/Button/Button.types';
import { BaseModal, Button } from '../../../../components/index';
import useIsMobile from '../../../../hooks/useIsMobile';

import styles from './ResultModal.module.scss';

type Props = {
    quantity: number;
    side: OrderSideEnum;
    handleClose: () => void;
}

const ResultModal = ({ quantity, side, handleClose }: Props) => {
  const orderStatus = useSelector((state: RootState) => state.trading.fxOrderStatus);
  const [showResult, setShowResult] = useState<boolean>(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowResult(true);
    }, PredefinedMilisecondsTypeEnum.twoHundredMilliseconds);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isMobile && showResult) {
        handleClose();
      }
    }, 4000);

    return () => clearTimeout(timer);
  }, [handleClose, isMobile, showResult]);

  const renderIcon = () => {
    if (orderStatus === 'completed') {
      return isMobile ? IconSuccessMob : IconSuccessWeb;
    }
    if (orderStatus === 'failed') {
      return isMobile ? IconRejectMob : IconRejectWeb;
    }

    return isMobile ? IconPendingMob : IconPendingWeb;
  };

  const renderContent = (currency: CurrencyEnum) => {
    if (orderStatus === 'completed') {
      return side === OrderSideEnum.Buy
        ? lang.walletExchangeSuccessBuy(formatNumber(quantity), currency)
        : lang.walletExchangeSuccessSell(formatNumber(quantity), currency);
    }
    if (orderStatus === 'failed') {
      return lang.walletExchangeReject(side, formatNumber(quantity), currency);
    }

    return lang.walletExchangePending(side, formatNumber(quantity), currency);
  };

  return isMobile ? (
    <div className={styles.wrapper}>
      { showResult
    && (
    <div className={styles.container}>
      <div className={styles.contentMob}>
        <img src={renderIcon()} alt="icon order orderStatus" />
        <div className={styles.resultStatus}>
          {renderContent(CurrencyEnum.EUR)}
        </div>
      </div>
      <Button className={styles.button} variant={ButtonTypesEnum.Tertiary} fullWidth onClick={handleClose}>
        {lang.commonOkay()}
      </Button>
    </div>
    )}
    </div>
  ) : (
    <BaseModal isOpen={showResult}>
      <div className={styles.contentWeb}>
        <img src={renderIcon()} alt="icon order orderStatus" />
        <h5 className={styles.resultStatus}>
          {renderContent(CurrencyEnum.EUR)}
        </h5>
      </div>
    </BaseModal>
  );
};

export default ResultModal;
